import { pick } from "lodash"
import actionCreator from "helpers/actionCreator"
import { createReducer } from "reduxsauce"
import { Types as ParentTypes } from "modules/analyze-forecast/model"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { DESC, orderState, handleSort } from "helpers/sorts"
import { ANALYZE_SECTION, createAnalyzeGroupingAndFilterReducer } from "helpers/analyze"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeForecastDetails", {
  show: {
    props: ["contributor"],
    track: true,
    trackType: "analyze-forecast-contributors-category-selected",
    trackPayload: ({ contributor: { label } }) => ({ type: label }),
  },
  hide: [],
  sort: {
    props: ["order"],
    track: true,
    trackType: "analyze-forecast-contributors-sorting",
    trackPayload: ({ order }) => order,
  },
  showGroup: {
    props: ["group"],
    track: true,
    trackType: "analyze-forecast-contributors-group-selected",
    trackPayload: ({ group: { name } }) => ({ label: name }),
  },
  hideGroup: [],
  setContributorsGrouping: {
    props: ["grouping"],
    track: true,
    trackType: "analyze-forecast-contributors-grouping-option-selected",
    trackPayload: ({ grouping }) => {
      let by
      if (grouping) {
        by = grouping.classificationId
          ? `${grouping.classificationId} - ${grouping.id}` : grouping.id
      }
      return { by }
    },
  },
  groupSort: {
    props: ["order"],
    track: true,
    trackType: "analyze-forecast-contributors-group-sorting",
    trackPayload: ({ order }) => ({ order }),
  },
})

const defaultOrder = orderState("viewType", DESC)

const DEFAULT_STATE = {
  selected: null,
  selectedGroup: null,
  order: defaultOrder,
  contributorsGrouping: null,
  groupOrder: {
    by: "value",
    order: "desc",
  },
}

function handleShow(state, { contributor }) {
  return { ...state, selected: contributor }
}

function handleHide(state) {
  return {
    ...state,
    selected: null,
    order: defaultOrder,
  }
}

function handleShowGroup(state, { group }) {
  return { ...state, selectedGroup: pick(group, ["id", "name", "description"]) }
}

function handleHideGroup(state) {
  return { ...state, selectedGroup: null }
}

function handleGroupSort(state, { order }) {
  return { ...state, groupOrder: { ...state.groupOrder, order } }
}

function handleSetContributorsGrouping(state, { grouping }) {
  let contributorsGrouping
  if (grouping) {
    contributorsGrouping = grouping
  }
  return { ...state, contributorsGrouping, selectedGroup: null }
}

function handleSetModel(state) {
  return { ...state, ...DEFAULT_STATE }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SORT]: handleSort,
  [Types.SHOW]: handleShow,
  [Types.HIDE]: handleHide,
  [Types.SHOW_GROUP]: handleShowGroup,
  [Types.HIDE_GROUP]: handleHideGroup,
  [Types.SET_CONTRIBUTORS_GROUPING]: handleSetContributorsGrouping,
  [Types.GROUP_SORT]: handleGroupSort,
  [ParentTypes.SET_DISPLAY_TYPE]: handleHide,
  [BaseTypes.SET_MODEL]: handleSetModel,
  ...createAnalyzeGroupingAndFilterReducer(ANALYZE_SECTION.TRENDS),
})
